import { ChangeEvent, useState, MouseEvent } from 'react';
import { ReactComponent as SearchIcon } from '../../assets/Icons/adornments/Search.svg';
import { ReactComponent as ClearIcon } from '../../assets/Icons/adornments/Close.svg';
import InputField from '../Form/InputField';
import Buttons from '../Buttons/Buttons';

export default function SearchBar({
    searchFn,
    options,
    label,
    placeholder,
    toggleFilter,
    filter,
    searchKey,
}: {
    searchFn?: (searchKey: string, searchQuery: string) => void,
    options?: { value: string, label: string }[],
    label?: string,
    placeholder?: string,
    toggleFilter?: (e:MouseEvent<HTMLButtonElement>) => void,
    filter?: {
        params: { [key: string]: any | null },
        paramsWithOptions: {
            label: string,
            options: { value: string, label: string }[],
        }[],
        filterFn: (appliedFilters: any[]) => void,
    }
    searchKey?: string,
}) {
    const [ input, setInput ] = useState('');

    const handleInput = (e:ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setInput(e.target.value);
    }





    return (
        <div className="w-full flex justify-start items-end gap-4">
                {options === undefined ? (
                    <div className="w-full flex flex-col justify-center items-start gap-2 text-default">
                        {label !== undefined && <label htmlFor='search' className={`text-[12px] font-medium`}>{label}</label>}
                        <div className="bg-white rounded-lg border border-outline hover:border-primary focus-within:border-primary w-full flex justify-between items-stretch overflow-hidden">
                            <input 
                                onChange={handleInput} 
                                onKeyDown={(e) => {
                                    e.stopPropagation()
                                    if (e.key === 'Enter') {
                                        searchFn && searchKey && searchFn(searchKey, input)
                                    }
                                }}
                                id='search' 
                                value={input} 
                                placeholder={placeholder ? placeholder : 'Search'} 
                                className="px-4 py-3 grow focus:outline-none"
                            />
                            {input && (
                                <button
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.preventDefault();
                                        searchFn && searchKey && searchFn(searchKey, '');
                                        setInput('');
                                    }}
                                    className="pr-4 flex justify-center items-center text-disable hover:text-primary transition-all"
                                >
                                    <div className='w-[24px] h-[24px]'><ClearIcon/></div>
                                </button>
                            )}
                            <button 
                                onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                    e.preventDefault(); 
                                    searchFn && searchKey && searchFn(searchKey, input)
                                }} 
                                className="pr-4 flex justify-center items-center text-disable hover:text-primary transition-all"
                            >
                                <div className='w-[18px] h-[18px]'><SearchIcon/></div>
                            </button>
                        </div>
                    </div>
                ) : (
                    <>
                        <InputField
                            label={label ? label : 'Search'}
                            type='text'
                            id='search'
                            name='input'
                            value={input}
                            isRequired={false}
                            handleChange={handleInput}
                        />
                        <Buttons
                            type='secondary'
                            label='Search'
                            id='search-btn'
                            styling='solid'
                            startingAdornment={<SearchIcon/>}
                        />
                    </>
                )}
                {/* {filter && (
                    <Filter 
                        params={filter.params}
                        paramsWithOptions={filter.paramsWithOptions}
                        filterFn={filter.filterFn}
                    />
                )} */}
        </div>
    )
}